module.exports = __webpack_public_path__ + "5e7b18404c77d1f9b5b91b4fea6fe3f3.png";